import {
  collection,
  getDocs,
  query,
  where
} from 'firebase/firestore'
import firebase from '../../firebase'
import { ref } from 'vue'

const getPostsessionsData = () => {
  const offDeviceSessionsReps = ref([])
  const postsessions = ref([])

  const fetchOffDeviceSessionsReps = async (userId, startTime, deviceType) => {
    offDeviceSessionsReps.value = []
    try {
      const q = query(
        collection(firebase.db, 'offDeviceSessions'),
        where('userId', '==', userId),
        where('date', '>=', startTime),
        where('deviceType', '==', deviceType)
      )
      const querySnapshot = await getDocs(q)

      querySnapshot.forEach((doc) => {
        const data = doc.data()
        if (data && data.exerciseReps) {
          // Assuming data.exerciseReps is an object with integer values
          const repsForSession = Object.values(data.exerciseReps).reduce((sum, reps) => {
            return sum + (typeof reps === 'number' ? reps : 0)
          }, 0)

          offDeviceSessionsReps.value.push({ startTime: data.date, reps: repsForSession })
        }
      })
    } catch (error) {
      console.log('Firebase error', error)
    }
  }

  const fetchPostsessionsDataForDeviceType = async (userId, startTime, deviceType) => {
    postsessions.value = []
    try {
      const q = query(
        collection(firebase.db, 'postsessions'),
        where('userId', '==', userId),
        where('startTime', '>=', startTime)
      )
      const querySnapshot = await getDocs(q)
      querySnapshot.forEach((doc) => {
        const data = doc.data()

        if (data && data.postsessions && data.postsessions.length && data.postsessions[0].deviceType === deviceType) {
          postsessions.value.push({
            data
          })
        }
      })
    } catch (error) {
      console.log('Firebase error', error)
    }
  }

  return {
    offDeviceSessionsReps,
    fetchOffDeviceSessionsReps,
    fetchPostsessionsDataForDeviceType,
    postsessions
  }
}
export default getPostsessionsData
